<template>
  <NuxtLayout>
    <JsonLDCollection :jsonOptions="jsonCollectionOptions" />
    <div class="slot-body">
      <h1 class="visually-hidden">{{ route.params.language === 'pt-br' ? 'Modelos Nuas e Ensaios Sensuais do Bella da Semana' : 'Nude Models and Sensual Photoshoots of Bella Club' }}</h1>
      <NavBarPages v-if="isMobile()"/>
      <div v-if="showBanner" @click="redirect('language-assine')">
        <img
          class="cursor-pointer"
          width="100%"
          height="100%"
          :src="route.params.language === 'pt-br' ?
                  (isMobile() ? BannerModeloMobileBr : BannerModeloDesktopBr) :
                  (isMobile() ? BannerModeloMobileEn : BannerModeloDesktopEn)"
        />
      </div>
      <div v-if="!showBanner" class="container">
        <div class="row pb-5 pt-4 align-items-center">
          <div class="col-lg-2 mt-4">
            <div class="title">
              {{ translate.title }}
            </div>
          </div>
          <div class="col-lg-5">
            <span class="subtitle">
              {{ translate.subTitle }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-12 search-desktop">
        <ModelSearch
          :options="options"
          @loadModel="mySelectEvent"
        />
      </div>
      <div class="block block--gray">
        <div class="container">
          <div class="search-mobile mb-3">
            <ModelSearch
              :options="options"
              @loadModel="mySelectEvent"
            />
          </div>
          <AllModelsPAgination v-if="showPaginate" :models="models" :categories="categories" />
          <ModelSingleCard v-else :models="models" />
        </div>
      </div>

      <div class="pt-5 pb-5 z-1 crsl-left">
        <div class="title-models pb-5">
          {{ translate.featuredModels }}
        </div>
        <div class="col-lg-12">
          <CarroselTopPeccin :posts="posts" />
        </div>
      </div>

      <div class="py-5">
        <BannerAssineHorizontal :path="bannerAssineHorizontal" />
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
// SEO: página de conteúdo explícito — marcação que o Google pede para não
// classificar o site inteiro como adulto. Ver composables/useAdultRating.ts
useAdultRating();
import CarroselTopPeccin from "@/components/Modelos/CarroselTopPeccin.vue";
import AllModelsPAgination from "@/components/Modelos/AllModelsPAgination.vue";
import BannerAssineHorizontal from "@/components/HomePage/BannerAssineHorizontal.vue";
import ModelSingleCard from "@/components/Modelos/ModelSingleCard.vue";
import JsonLDCollection from "@/components/JsonLDCollection.vue";
import { isMobile } from "@/shared/utils/mobile";
import modelsTradutor from "@/tradutors/models";
import api from "@/api";
import ModelSearch from "@/components/Modelos/ModelSearch.vue";
import BannerModeloDesktopBr from "@/assets/img/banner-modelo-desktop-br.webp";
import BannerModeloDesktopEn from "@/assets/img/banner-modelo-desktop-en.webp";
import BannerModeloMobileBr from "@/assets/img/banner-modelo-mobile-br.webp";
import BannerModeloMobileEn from "@/assets/img/banner-modelo-mobile-en.webp";
import NavBarPages from "~/components/Modelos/NavBarPages.vue";

definePageMeta({
  middleware: ["not-found-lang"],
});

const route = useRoute();
const canonical = useCanonicalUrl();
const router = useRouter();
const translate = computed(() =>
  (route.params.language) == "pt-br"
    ? modelsTradutor.portugues
    : modelsTradutor.ingles
);

const url = useRequestURL();

const storeUser = userStore();
const showBanner = computed(() => !storeUser.isActiveUser);

const seo = await useSeoConfig(String(route.name), String(route.params.language));

useHead({
  templateParams: {
    subTitle: null,
    subPage: seo.value?.title || translate.value.title,
    page_url: canonical,
    page_description:
      seo.value?.description ||
      (route.params.language == "pt-br"
        ? `Conheça as Bellas que fazem qualquer homem delirar!`
        : `Meet the Bellas that make any man delirious!`),
    page_image: shareImage(seo.value?.image),
    page_keywords:
      seo.value?.keywords ||
      "bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site",
    page_locale: route.params.language as string,
    page_url_pt: "https://belladasemana.com.br/pt-br/modelos",
    page_url_en: "https://belladasemana.com.br/en/modelos",
    page_canonical: canonical,
  },
});

const { $getCachedData } = useNuxtApp();
const key: string = "get-models-all-" + route.params.language;

var cachedData = $getCachedData(key);
if (!cachedData) {
  const { data } = await useAsyncData(key, async () => {
    const modelsArray = await api
      .get("v1/modelos/getAllModels?order=order&language=" + route.params.language)
      .then(({ data }) => {
        return data.modelsArray;
      });

    const postsCarroselModels = await api
      .get("v1/modelos/getLastFiveModels?language=" + route.params.language)
      .then(({ data }) => {
        return data.postsCarroselModels;
      });

    const bannerAssineHorizontal = await api
      .get(
        `v1/home/getBannerSuper?mobile=${isMobile()}&language=${
          route.params.language
        }`
      )
      .then(({ data }) => {
        return data.bannerAssineHorizontal;
      });

    const categories = await api
      .get("v1/modelos/categories?language=" + route.params.language)
      .then(({ data }) => data.categories)
      .catch(() => []);

    return { modelsArray, postsCarroselModels, bannerAssineHorizontal, categories };

  });

  if (!data.value)
    throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
  cachedData = data.value;
}

const dadosSSR = ref(cachedData);

const posts = ref(dadosSSR.value.postsCarroselModels);
const models = ref(dadosSSR.value.modelsArray);
const categories = ref(dadosSSR.value.categories ?? []);
const showPaginate = ref(true);
const bannerAssineHorizontal = ref(dadosSSR.value.bannerAssineHorizontal);
const options = ref([]);

const jsonCollectionOptions = computed(() => {
  const list = dadosSSR.value.modelsArray;
  return {
    name: seo.value?.title || translate.value.title,
    description:
      seo.value?.description ||
      (route.params.language == "pt-br"
        ? "Descubra as modelos mais sensuais do Bella da Semana: loiras, morenas, fitness, novinhas e MILFs em ensaios exclusivos."
        : "Discover the most sensual models on Bella Club: blondes, brunettes, fitness, and more in exclusive photo shoots."),
    url: canonical,
    numberOfItems: list?.total,
    items: (list?.data || []).map((m: any) => ({
      name: m.title,
      image: m.cover,
      url:
        url.origin +
        router.resolve({
          name: "language-modelos-name-photo",
          params: { language: route.params.language, name: m.slug },
        }).href,
    })),
  };
});

onMounted(() => {
  getSelectModels();
});

async function getModels() {
  api.get("v1/modelos/getAllModels?order=order&language=" + route.params.language).then(({ data }) => {
    models.value = data.modelsArray;
    showPaginate.value = true;
  });
}

async function getSelectModels() {
  api.get("v1/modelos/getAllModelsSelect").then(({ data }) => {
    options.value = data.modelsArray;
  });
}
function mySelectEvent(val: number) {
  if (val === undefined) {
    getModels();
  } else {
    api.get("v1/modelos/getModelSelect/" + val + "?language=" + route.params.language).then(({ data }) => {
      models.value = data.modelsArray;
      showPaginate.value = false;
    });
  }
}

function redirect(name: string) {
  router.push({ name, params: { language: route.params.language } });
}

</script>

<style scoped lang="css">
.slot-body {
  margin-top: 65px !important;
  background-color: #fff !important;
}

.title {
  font-family: "Bebas-Neue-Light";
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.title-models {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 38px;
}

.subtitle {
  color: #5b5858;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.search-desktop {
  transform: translate(25%);
  z-index: 3;
  width: 340px;
  position: absolute;
  right: 190px;
  margin-top: 26px;
}

.search-desktop-assinante {
  transform: translate(25%);
  z-index: 3;
}

.search-mobile {
  display: none;
}

.crsl-left {
  margin-left: 90px;
}

.block {
  padding: 30px 0;
}

@media screen and (max-width: 992px) {
  .search-desktop {
    transform: unset;
  }
}

/* tablets e iPads: busca em fluxo como 1ª linha, acima da toolbar */
@media screen and (min-width: 770px) and (max-width: 1300px) {
  .search-desktop {
    display: none;
  }

  .search-mobile {
    display: block;
    z-index: 3;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media screen and (max-width: 769px) {
  .title-models {
    font-size: 24px;
    padding-bottom: 20px !important;
  }

  .search-desktop, .search-desktop-assinante {
    display: none;
  }

  .search-mobile {
    display: block;
    z-index: 3;
  }

  .crsl-left {
    margin-left: 8px;
    padding-top: 20px !important;
  }

  .title {
    font-family: "Bebas-Neue-Light";
    color: #000000;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 58px;
  }
  .z-2 {
    padding-top: 30px !important;
  }
  .subtitle {
    color: #5b5858;
    font-family: "Roboto-Medium";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }
}
</style>
